
// Client Selection Logic
function updateClientSelection() {
    const $checkboxes = $(".client-checkbox");
    const $checked = $checkboxes.filter(":checked");
    const count = $checked.length;

    const $toolbar = $("#selectionToolbar");
    const $countEl = $("#selectedCount");
    const $labelEl = $("#selectedLabel");

    if ($countEl.length) {
        $countEl.text(count);
    }

    if ($labelEl.length) {
        $labelEl.text(count > 1 ? "itens" : "item");
    }

    if ($toolbar.length) {
        if (count > 0) {
            $toolbar.removeClass("d-none");
        } else {
            $toolbar.addClass("d-none");
        }
    }

    // Update Select All checkbox state
    const $selectAll = $("#selectAllClients");
    if ($selectAll.length && $checkboxes.length > 0) {
        $selectAll.prop("checked", count === $checkboxes.length);
        $selectAll.prop("indeterminate", count > 0 && count < $checkboxes.length);
    }
}

$(document).on("change", ".client-checkbox", function () {
    updateClientSelection();
});

$(document).on("change", "#selectAllClients", function () {
    const isChecked = $(this).is(":checked");
    $(".client-checkbox").prop("checked", isChecked);
    updateClientSelection();
});

$(document).on("click", "#clearSelectionLink", function (e) {
    e.preventDefault();
    $(".client-checkbox").prop("checked", false);
    $("#selectAllClients").prop("checked", false);
    updateClientSelection();
});

// Re-initialize selection on table update (e.g. infinite scroll or filter)
$(document).on("clientesCarregados", function () {
    updateClientSelection();
});
